import {Avatar, Paper, Stack, Typography} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import {getDisplayPriceByValue} from "../../utils/helpers/LocalPrice";
import {BrandIcon} from "../../utils/assets/BrandIcon";
import {Brand} from "../../utils/model/Station";
import {Color} from "../../utils/assets/ColorFromFiability";
import FiabilityIcon from "../common/FiabilityIcon";
import {lightGreenBackgroundColor, fontFamilyMuseo700} from "../../mui/Theme";
import {FiabilityLevel} from "../../utils/model/FiabilityLevel";
import {BboxStation} from "../../utils/model/BboxResult";

interface Props {
    station: BboxStation;
    isCheapest: boolean;
    active: boolean;
}

export const GMapInfo = ({station, isCheapest, active}: Props) => {
    const fiabilityColor = Color.forFiabilityLevel(station.fiability);
    const imageSize = active ? 36 : 32;
    const border = active ? 4 : 2;
    const background = isCheapest ? lightGreenBackgroundColor : "white";
    const priceToDisplay = getDisplayPriceByValue(station.id, station.fuel, station.price);

    return (
        <Paper className='marker-info' elevation={2}
               sx={{
                   background: background,
                   p: '1px',
                   borderRadius: '32px',
                   border: border,
                   borderColor: fiabilityColor
               }}>
            <Grid container gap={0.5} wrap='nowrap' alignItems={'center'}>
                <Grid flexShrink={0}>
                    <Avatar alt="" src={BrandIcon.forBrand(station.brand as Brand)} sx={{
                        width: imageSize, height: imageSize
                    }}/>
                </Grid>
                <Stack mr={0.75}>
                    <Stack direction={'row'} alignItems={'flex-end'} gap={0.5}>
                        <Typography fontSize={14} fontFamily={fontFamilyMuseo700} lineHeight={1}>
                            {priceToDisplay}
                        </Typography>
                        {station.fiability === FiabilityLevel.CONFIDENT &&
                            <FiabilityIcon fiabilityLevel={station.fiability} iconSize={15}/>
                        }
                    </Stack>
                </Stack>
            </Grid>
        </Paper>
    )
}
